import { render, staticRenderFns } from "./FirstNationSelect.vue?vue&type=template&id=989a2a88&scoped=true&lang=pug"
import script from "./FirstNationSelect.vue?vue&type=script&lang=js"
export * from "./FirstNationSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989a2a88",
  null
  
)

export default component.exports